// /app/testimonial/page.jsx
"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import Image from "next/image";

export default function TestimonialPage() {
    const testimonials = [
        {
          name: "Viona Charista",
          avatar: "/images/Viona Charista.png",
          title: "Customer Macspace",
          rating: 5,
          content: "Sangat efesien, karena ada service pick up ke rumah. Kualitas jasa dan produk dengan harga juga sepadan, ditambah ada garansi 3 bulan untuk penggantian baterai. Tim cs juga sangat responsif. Overall I had a great experience with the service. Thank you!",
        },
        {
          name: "Valensya Sie",
          avatar: "/images/valensya sie.png",
          title: "Customer Macspace",
          rating: 5,
          content: "Admin Kiky helped me through resetting my MacBook password 🙏🏻 Quick and easy",
        },{
            name: "Nur Isti Khomalia",
            avatar: "/images/Nur Isti Khomalia.png",
            title: "Customer Macspace",
            rating: 5,
            content: "Saya sangat puas dengan pelayanan yang diberikan. Prosesnya sangat cepat dan profesional. Tim teknisi sangat ramah dan membantu dalam memilih SSD yang tepat untuk MacBook saya, serta menjelaskan proses penggantian dengan sangat rinci. Recommend!",
          },
          {
            name: "Cindy",
            avatar: "/images/cindy.png",
            title: "Customer Macspace",
            rating: 5,
            content: "I panicked when my laptop went black after a water spill. Thankfully, the technician explained everything clearly, what to expect, the risks, and so on. The actual repair only took a day.",
          },
      ];
      
      return (
        <section className="w-full max-h-[90vh] bg-[#232323] py-16">
          <div className="w-full px-6 md:px-16 lg:px-32">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-1">
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <span className="w-2 h-2 rounded-full bg-[#B91C1C]"></span>
                  <span className="text-[#f33e17] tracking-widest font-semibold text-sm">TESTIMONIALS</span>
                </div>
                <h2 className="text-white font-bold text-4xl md:text-5xl">
                  Thank you for being our<br />customer
                </h2>
              </div>
              <a
                href="https://maps.app.goo.gl/5LunSdvsWyTumL1q9"
                target="_blank"
                className="bg-[#B91C1C] hover:bg-[#991B1B] transition rounded-lg text-[#fff] font-semibold py-3 px-8 mt-6 md:mt-0"
              >
                View All Review
              </a>
            </div>
            <Swiper
              modules={[Autoplay, Pagination]}
              spaceBetween={40}
              slidesPerView={2}
              loop
              autoplay={{ delay: 3500, disableOnInteraction: false }}
              pagination={{ clickable: true }}
              breakpoints={{
                0: { slidesPerView: 1 },
                900: { slidesPerView: 2 },
              }}
              className="pb-20" // padding bawah besar agar dots turun
            >
              {testimonials.map((item, i) => (
                <SwiperSlide key={i}>
                  <a
                    href="https://www.google.com/maps/place/Service+MacBook+Jakarta+-+MacSpace.id/@-6.1372647,106.8239132,17z/data=!4m18!1m9!3m8!1s0x2e698dc40a704911:0xbfe555f493fda07!2sService+MacBook+Jakarta+-+MacSpace.id!8m2!3d-6.1372647!4d106.8239132!9m1!1b1!16s%2Fg%2F11jygg4frg!3m7!1s0x2e698dc40a704911:0xbfe555f493fda07!8m2!3d-6.1372647!4d106.8239132!9m1!1b1!16s%2Fg%2F11jygg4frg?entry=ttu&g_ep=EgoyMDI1MDcyMS4wIKXMDSoASAFQAw%3D%3D"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ display: 'block', height: '100%' }} // Supaya seluruh card bisa di klik
                  >
                    <div className="bg-[#232323] border border-gray-700 rounded-2xl p-8 flex flex-col gap-6 h-full shadow-xl transition-all duration-300">
                      {/* ... sisanya sama persis ... */}
                      <div className="flex items-center justify-between gap-2">
                        <div className="flex items-center gap-3">
                          <Image
                            src={item.avatar}
                            width={44}
                            height={44}
                            className="rounded-full"
                            alt={item.name}
                          />
                          <div>
                            <div className="font-bold text-white">{item.name}</div>
                            <div className="text-gray-300 text-sm">{item.title}</div>
                          </div>
                        </div>
                        <div className="flex gap-1 text-yellow-400">
                          {Array.from({ length: item.rating }).map((_, idx) => (
                            <svg key={idx} viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5 inline">
                              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.967a1 1 0 00.95.69h4.184c.969 0 1.371 1.24.588 1.81l-3.39 2.462a1 1 0 00-.364 1.118l1.287 3.966c.3.922-.755 1.688-1.54 1.118l-3.39-2.462a1 1 0 00-1.175 0l-3.39 2.462c-.785.57-1.84-.196-1.54-1.118l1.287-3.966a1 1 0 00-.364-1.118L2.049 9.394c-.783-.57-.38-1.81.588-1.81h4.184a1 1 0 00.95-.69l1.286-3.967z" />
                            </svg>
                          ))}
                        </div>
                      </div>
                      <div className="border-t border-gray-700 pt-5 text-white text-lg">
                        {item.content}
                      </div>
                    </div>
                  </a>
                </SwiperSlide>
              ))}

            </Swiper>
          </div>
          <style jsx global>{`
            .swiper-pagination {
              display: none;
              bottom: -10px !important;
            }
            @media (min-width: 768px) {
              .swiper-pagination {
                display: none;
                bottom: 20px !important;
              }
            }
          `}</style>
        </section>
      );
}
